/* eslint-disable react/no-unstable-nested-components */
import React, { memo, useEffect } from "react";
import { Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import AppDownload from "../MobileApp/AppDownload";
import { updateLoggedInUser } from "../../Redux/Slices/loggedInUser.slice";

const GetStartedScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    let timeout;
    const tokenExist = localStorage.getItem("token");

    if (tokenExist) {
      dispatch(updateLoggedInUser({ key: "loading", value: true }));

      timeout = setTimeout(() => {
        dispatch(updateLoggedInUser({ key: "loading", value: false }));
        navigate("/home");
      }, 1500);
    }

    return () => clearTimeout(timeout);
  }, [dispatch, navigate]);

  // show the download app screen when on mobile resolution
  return (
    <div>
      <div className="hidden lg:block w-screen h-screen">
        <Row className="h-full">
          <Col span={15} className="h-full overflow-hidden">
            <img
              src="/assets/images/Login/login-image-new.png"
              alt="LoginImage"
              className="object-cover w-full h-full"
            />
          </Col>

          <Col span={9}>
            <div className="flex flex-col items-center justify-center w-full h-full font-poppins bg-background-white">
              <img
                src="/assets/songa-main-logo.svg"
                alt="Songa Mobility"
                className="w-[258px] h-14"
              />

              <p className="my-4 text-base font-medium leading-[100%] text-center font-poppins pb-4 border-b border-light-grey w-[312px] capitalize">
                Let’s get started
              </p>

              <div className="text-xs font-light text-center text-dark-gray">
                Already have an account?
              </div>

              <button
                type="button"
                className="mt-2 px-4 py-3 h-10.5 w-[312px] bg-yellow hover:bg-yellow-dark text-black disabled:bg-primary rounded-md"
                onClick={() => navigate("/login")}
              >
                <p className="font-poppins font-medium text-xs leading-[100%]">
                  Login
                </p>
              </button>

              <p className="mt-3 mb-2 text-grey-200 font-medium font-poppins text-xs leading-[100%]">
                OR
              </p>

              <div className="text-xs font-light text-center text-dark-gray">
                Create your account by signing up.
              </div>

              <button
                type="button"
                className="mt-2 px-4 py-3 h-10.5 w-[312px] bg-primary hover:bg-primary-50 text-background-white disabled:bg-primary rounded-md"
                onClick={() => navigate("/sign-up")}
              >
                <p className="font-poppins font-medium text-xs leading-[100%]">
                  Sign Up
                </p>
              </button>
            </div>
          </Col>
        </Row>
      </div>

      <div className="block lg:hidden">
        <AppDownload />
      </div>
    </div>
  );
};
export default memo(GetStartedScreen);
